import type { PartnerConnectStatus } from './api';
import { payoutSetupCopy } from './payoutSetupCopy';

/** Green banner shown once after Stripe confirms the payout account is ready. */
export const PAYOUT_SETUP_COMPLETE_MESSAGE = payoutSetupCopy('en').spSetupComplete;

/** The copy follows `locale` (payoutLocale() on the screen); English when it is left out. */
export function partnerConnectPresentation(status: PartnerConnectStatus | undefined, hasAccount: boolean, locale: unknown = 'en') {
  const text = payoutSetupCopy(locale);
  if (!status) return { message: hasAccount ? text.spMessageFinish : text.spMessageStart,
    button: hasAccount ? text.spButtonFinish : text.spButtonStart, pill: hasAccount ? text.spPillUnfinished : text.spPillNotSetUp, ready: false, dashboard: false };
  if (status.state === 'ready') return { message: '', button: '', pill: text.spPillActive, ready: true, dashboard: status.details_submitted };
  if (status.state === 'restricted') return { message: text.spMessageRestricted, button: text.spButtonRestricted, pill: text.spPillRestricted, ready: false, dashboard: status.details_submitted };
  if (status.state === 'pending' && status.details_submitted && !status.information_due) return {
    message: text.spMessageChecking, button: '', pill: text.spPillChecking, ready: false, dashboard: true };
  const started = status.state !== 'not_started';
  return { message: started ? text.spMessageFinish : text.spMessageStart,
    button: started ? text.spButtonFinish : text.spButtonStart, pill: started ? text.spPillUnfinished : text.spPillNotSetUp, ready: false, dashboard: status.details_submitted };
}
